import {
  UPDATE_PROFILE,
  UPDATE_SETTING,
  UPDATE_SITE,
  UPDATE_RUNTIME,
  // SOCKET_RECEIVED,
  SOCKET_CONNECT,
  SOCKET_CLOSE,
  SOCKET_SEND,
} from "./actionTypes";

// profile
export const updateProfile = (content) => ({
  type: UPDATE_PROFILE,
  payload: {
    content,
  },
});
export const updateSetting = (content) => ({
  type: UPDATE_SETTING,
  payload: {
    content,
  },
});

export const updateRuntime = (content) => ({
  type: UPDATE_RUNTIME,
  payload: content,
});

export const updateSite = (content) => ({
  type: UPDATE_SITE,
  payload: content,
});

export const socketSendMsg = (msg) => ({
  type: SOCKET_SEND,
  payload: msg,
});
export const socketConnect = () => ({
  type: SOCKET_CONNECT,
});
export const socketClose = () => ({
  type: SOCKET_CLOSE,
});
